const initRelatedPostsSliderWidget = () => {
    initCarousel("[data-related-posts-slider]", cellAlign.center, false, false, false, false, true, 1024, true);
};
